
<div>
  <TextField
    id="phone"
    v-model="form.phoneNumber"
    v-maska
    mask="(###) ###-####"
    labelName="Mobile Number"
    name="phone"
    type="tel"
    inputmode="tel"
    autocomplete="tel"
    aria-label="Mobile Phone Number"
    :status="formStatuses.phoneNumber"
    :required="true"
    :helperText="helperText(formStatuses.phoneNumber)"
    @blur="validatePhone"
  />
  <HelperText
    customClasses="mb-24 leading-5"
    text="I consent to receive text messages. We won't display your phone number to other members."
    :status="2"
  />
</div>
